import { useMemo, useState } from 'react'
import { validationApiFetch } from '../../../api/apis'

export function useValidationFetch(params) {
  const { appHosts, id } = params
  const [validationData, selectValidationData] = useState(null)
  const msv = appHosts?.filter(host => host.software_type === 'MA_MSV')[0]
  const msvHost = msv?.url

  useMemo(() => {
    if (!msvHost) return
    if (!id) return
    if (validationData) return

    validationApiFetch(msvHost, id)
      .then(response => {
        if (response.errors) {
          throw new Error(response.errors)
        }
        selectValidationData(response)
      })
      .catch(error => {
        throw new Error(error)
      })
  }, [id, msvHost, validationData])

  return {
    data: validationData || { count: 0, actions: [] },
  }
}
